<template>
  <v-card
    class="radius-10 mb-6 elevation-5"
  >
    <v-card-text class="pa-6">
      <v-row no-gutters>
        <v-col>
          <div class="title">
            {{ navigareCompany.name }}
          </div>
          <span v-if="navigareCompany.parent">
            PARENT
          </span>
        </v-col>
        <v-col cols="auto">
          <v-btn
            v-if="$can('edit', 'NavigareCompany')"
            small
            class="ma-0"
            @click.native="$emit('editNavigareCompany', navigareCompany)"
          >
            <v-icon
              left
              small
            >
              edit
            </v-icon>
            Edit
          </v-btn>
        </v-col>
      </v-row>
      <div class="mt-2">
        <v-chip
          outlined
          class="ma-0"
        >
          {{ navigareCompany.country.name }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import NavigareCompany from '@/models/NavigareCompany'

export default {
  name: 'NavigareCompanyCard',
  props: {
    navigareCompany: {
      type: Object,
      default: () => NavigareCompany.emptyModel
    }
  }
}
</script>
